/** Match only the claim-work reads that can carry private search/filter values. */
export function adminClaimWorkEndpointTemplate(url: string): string | undefined {
  let path: string;
  try {
    path = new URL(url, 'https://telemetry.invalid').pathname;
  } catch {
    return undefined;
  }
  const match = path.match(
    /^\/(?:api\/)?v2\/admin\/billing\/dashboard\/organizations\/[^/]+\/claim-work(\/(?:filter-options|patient-options))?\/?$/,
  );
  return match
    ? `/v2/admin/billing/dashboard/organizations/:organizationId/claim-work${match[1] ?? ''}`
    : undefined;
}

/** Exact paid-resolution reads/commands carry private claim evidence and optional notes. */
export function paidClaimResolutionEndpointTemplate(url: string): string | undefined {
  let path: string;
  try {
    path = new URL(url, 'https://telemetry.invalid').pathname;
  } catch {
    return undefined;
  }
  const match = path.match(
    /^\/(?:api\/)?v2\/provider\/billing\/v2\/claims\/[^/]+\/paid-resolution(\/(?:resolve|reopen))?\/?$/,
  );
  return match
    ? `/v2/provider/billing/v2/claims/:claimId/paid-resolution${match[1] ?? ''}`
    : undefined;
}
